const entities: Record<string, string> = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

/** Toasts render their message as HTML, so text another person typed (a portfolio's name) is escaped before it goes in. */
export function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (character) => entities[character]);
}
